// структура элементов для добавления информации о новом питомце для админа
<template>
  <!-- Two-way Data-Binding -->
  <!-- <quill-editor
    ref="myQuillEditor"
    v-model="content"
    :options="editorOption"
    @blur="onEditorBlur($event)"
    @focus="onEditorFocus($event)"
    @ready="onEditorReady($event)"
  /> -->

  <!-- Or manually control the data synchronization -->
  <quill-editor
 
    :content="content"
    :options="editorOption"
    @change="onEditorChange($event)"
  />


</template>

<script>

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'


export default {
  data() {
    return {
      content: '<h4>Ваш текст...</h4>',
        editorOption: {
          modules: {
            toolbar: [
              ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
              // ['blockquote', 'code-block'],

              [{ 'header': 1 }, { 'header': 2 } ],               // custom button values
              [{ 'list': 'ordered'}, { 'list': 'bullet' }],
              [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
              // [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
              // [{ 'direction': 'rtl' }],                         // text direction

              // [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
              [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

              [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
              [{ 'font': [] }],
              // [{ 'align': [] }],
               ['link'],
              ['clean']          
            ]
          },
          theme: 'snow',
            
        },

      text: '',
    }
  },

  // created () {
  //   return this.$store.dispatch('DELETE_QUILL_HTML');
  // },

  methods: {

    // onEditorBlur(quill) {
    //     console.log('editor blur!', quill)
    //   },
    //   onEditorFocus(quill) {
    //     console.log('editor focus!', quill)
    //   },
    //   onEditorReady(quill) {
    //     console.log('editor ready!', quill)
    //   },
      //  onEditorChange({ quill, html, text }) {
      //   console.log('editor change!', quill, html, text)
      //   this.content = html
      // },
      onEditorChange({ html }) {
        // console.log('editor change!', quill, html, text)
        // this.content = html
        this.$store.dispatch('UPDATE_QUILL_HTML', html);
      },
  },

   components: {
    quillEditor
  },
 

}
</script>

